export interface TimezoneOption {
  label: string;
  value: string;
}

// Curated set of commonly-needed IANA zone names (not exhaustive tz-database
// coverage — see plan.md's Architecture Decisions for why this isn't sourced
// from Intl.supportedValuesOf('timeZone')).
export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { label: 'UTC', value: 'UTC' },
  { label: 'Azores (Atlantic/Azores)', value: 'Atlantic/Azores' },
  { label: 'London, Lisbon (Europe/London)', value: 'Europe/London' },
  { label: 'Paris, Berlin, Madrid (Europe/Paris)', value: 'Europe/Paris' },
  { label: 'Athens, Helsinki (Europe/Athens)', value: 'Europe/Athens' },
  { label: 'Moscow (Europe/Moscow)', value: 'Europe/Moscow' },
  { label: 'Istanbul (Europe/Istanbul)', value: 'Europe/Istanbul' },
  { label: 'Dubai (Asia/Dubai)', value: 'Asia/Dubai' },
  { label: 'Karachi (Asia/Karachi)', value: 'Asia/Karachi' },
  { label: 'New Delhi, Mumbai (Asia/Kolkata)', value: 'Asia/Kolkata' },
  { label: 'Dhaka (Asia/Dhaka)', value: 'Asia/Dhaka' },
  { label: 'Bangkok, Jakarta (Asia/Bangkok)', value: 'Asia/Bangkok' },
  {
    label: 'Singapore, Kuala Lumpur (Asia/Singapore)',
    value: 'Asia/Singapore',
  },
  {
    label: 'Hong Kong, Beijing, Shanghai (Asia/Shanghai)',
    value: 'Asia/Shanghai',
  },
  { label: 'Tokyo, Seoul (Asia/Tokyo)', value: 'Asia/Tokyo' },
  { label: 'Perth (Australia/Perth)', value: 'Australia/Perth' },
  { label: 'Adelaide (Australia/Adelaide)', value: 'Australia/Adelaide' },
  { label: 'Sydney, Melbourne (Australia/Sydney)', value: 'Australia/Sydney' },
  { label: 'Auckland (Pacific/Auckland)', value: 'Pacific/Auckland' },
  { label: 'Honolulu (Pacific/Honolulu)', value: 'Pacific/Honolulu' },
  { label: 'Anchorage (America/Anchorage)', value: 'America/Anchorage' },
  {
    label: 'Los Angeles, Vancouver (America/Los_Angeles)',
    value: 'America/Los_Angeles',
  },
  { label: 'Denver, Phoenix (America/Denver)', value: 'America/Denver' },
  { label: 'Chicago, Mexico City (America/Chicago)', value: 'America/Chicago' },
  { label: 'New York, Toronto (America/New_York)', value: 'America/New_York' },
  { label: 'Halifax (America/Halifax)', value: 'America/Halifax' },
  { label: 'Sao Paulo (America/Sao_Paulo)', value: 'America/Sao_Paulo' },
  {
    label: 'Buenos Aires (America/Argentina/Buenos_Aires)',
    value: 'America/Argentina/Buenos_Aires',
  },
  { label: 'Santiago (America/Santiago)', value: 'America/Santiago' },
  { label: 'Cairo (Africa/Cairo)', value: 'Africa/Cairo' },
  { label: 'Johannesburg (Africa/Johannesburg)', value: 'Africa/Johannesburg' },
  { label: 'Lagos (Africa/Lagos)', value: 'Africa/Lagos' },
  { label: 'Nairobi (Africa/Nairobi)', value: 'Africa/Nairobi' },
];
